export default "__VITE_ASSET__CfFn4Rm7__"